import type { ReactNode } from 'react';

import { DiaryPreview } from './landing/previews';

/**
 * Um case — produto nosso ou projeto feito para um cliente. Para adicionar um, basta
 * incluir uma entrada em `cases`: a seção "Cases" monta um card por entrada, e os
 * produtos próprios com site entram no rodapé.
 */
export type CaseStudy = {
  /** Identificador estável, sem acentos: vira âncora e chave. */
  slug: string;
  name: string;
  /** Uma frase: o que é e para quem. É tudo o que o card mostra de texto. */
  summary: string;
  /** Nome do cliente. Sem cliente, é produto próprio da VincDev. */
  client?: string;
  status: 'em-operacao' | 'em-desenvolvimento' | 'entregue';
  /** Site público — habilita o link "Conhecer". */
  url?: string;
  /** Etiquetas curtas, no máximo três: "Web", "Android e iOS"… */
  tags: string[];
  /** Uma "tela" de `landing/previews.tsx`, mostrada no alto do card. Sem ela, as iniciais. */
  preview?: ReactNode;
  /** Tira o case do site sem apagar a entrada. */
  hidden?: boolean;
};

const allCases: CaseStudy[] = [
  {
    slug: 'conecta-kids',
    name: 'Conecta Kids',
    summary:
      'Diário digital para creches e berçários: a professora registra o dia, a família acompanha na hora pelo aplicativo.',
    status: 'em-operacao',
    url: 'https://conectakids.vincdev.com.br',
    tags: ['Web', 'Android e iOS'],
    preview: <DiaryPreview />,
  },
  // ---- MODELO: copie este bloco para adicionar um case, preencha e apague o `hidden`.
  // Ele não aparece no site enquanto tiver `hidden: true`. Campos opcionais: `client`
  // (sem ele, o card diz "Produto próprio"), `url` e `preview`.
  {
    slug: 'agenda-da-clinica',
    name: 'Agenda da Clínica',
    summary:
      'Agendamento online e lembretes automáticos por WhatsApp para uma clínica de fisioterapia: menos faltas, sem telefone tocando.',
    client: 'Clínica Exemplo',
    status: 'entregue',
    tags: ['Web', 'WhatsApp'],
    hidden: true,
  },
];

/** Todos, inclusive os ocultos — só para o teste que confere as entradas. */
export const allCaseEntries: readonly CaseStudy[] = allCases;

/** Os cases publicados, na ordem em que aparecem. */
export const cases = allCases.filter((study) => !study.hidden);

/** Produtos da própria VincDev (sem cliente). */
export const ownProducts = cases.filter((study) => !study.client);
